import { apiRequest } from './api';
import { Prompt } from '../store/prompt/types';

export const getAllPrompts = async (tag?: string): Promise<Prompt[]> => {
  return apiRequest<Prompt[]>('/admin/prompts', {
    params: tag ? { tag } : undefined,
  });
};

export const getPromptContent = async (name: string): Promise<string> => {
  const response = await apiRequest<{ content: string }>(`/admin/prompts/content/${name}`);
  return response.content;
};

export const createPrompt = async (prompt: Prompt): Promise<Prompt> => {
  return apiRequest<Prompt>('/admin/prompts', {
    method: 'POST',
    data: prompt,
  });
};

export const updatePrompt = async (id: string, prompt: Prompt): Promise<Prompt> => {
  return apiRequest<Prompt>(`/admin/prompts/${id}`, {
    method: 'PUT',
    data: prompt,
  });
};
